import { createContext, useContext, useState } from "react";
import {
  getAllCareTeamGroupProgramsList,
  getCareTeamProvider,
  getCareTeams,
  getCareTeamsforAdmin,
} from "../services/CareTeam";
import { useAuth } from "./AuthContext";

const CareTeamContext = createContext({});

export const CareTeamContextProvider = ({ children }) => {
  const { isAdmin } = useAuth();
  const [allTeams, setAllTeams] = useState([]);
  const [isLoading, setLoader] = useState(false);
  const [allProvider, setAllProvider] = useState([]);
  const [editData, setEditData] = useState();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [renderGroupSignal, setGroupSignal] = useState(false);
  const [renderProgramSignal, setProgramSignal] = useState(false);
  const [renderProviderSignal, setProviderSignal] = useState(false);
  // useEffect(() => {
  //   getAllProviders();
  //   getAllCareTeams();
  // }, []);

  const getAssignedGroupPrograms = async (type = "") => {
    setLoader(true);
    try {
      const response = await getAllCareTeamGroupProgramsList(type);
      if (response.status !== 200) {
        setLoader(false);
        return [];
      }
      setLoader(false);
      return response?.data?.data;
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const getAllProviders = async () => {
    setLoader(true);
    try {
      const response = await getCareTeamProvider();
      if (response.status !== 200) {
        setAllProvider([]);
        setLoader(false);
        return;
      }
      setAllProvider(response?.data?.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const getAllCareTeams = async () => {
    setLoader(true);
    try {
      const response = isAdmin
        ? await getCareTeamsforAdmin()
        : await getCareTeams();
      if (response.status !== 200) {
        setAllTeams([]);
        setLoader(false);
        return;
      }
      setAllTeams(response?.data?.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  return (
    <CareTeamContext.Provider
      value={{
        allTeams,
        setAllTeams,
        isLoading,
        setLoader,
        allProvider,
        setAllProvider,
        getAllProviders,
        getAllCareTeams,
        getAssignedGroupPrograms,
        setEditData,
        editData,
        createModalOpen,
        setCreateModalOpen,
        renderGroupSignal,
        setGroupSignal,
        renderProgramSignal,
        setProgramSignal,
        renderProviderSignal,
        setProviderSignal,
      }}
    >
      {children}
    </CareTeamContext.Provider>
  );
};

// Create a custom hook to easily access the context values
export const useCareTeamContext = () => {
  return useContext(CareTeamContext);
};
